"use client";
import React from "react";

import { BoxSx, Target } from "../../foundations";

export type LinkProps = React.ComponentProps<typeof Target> & {
  children: Exclude<React.ReactNode, undefined | null | boolean>;
};

export const Link: React.FC<LinkProps> = (props: LinkProps) => {
  const { children, disabled = false, sx, ...restProps } = props;

  const linkStyles: BoxSx = {
    alignItems: "center",
    color: disabled ? "text-disabled" : "text-link",
    fontSize: "inherit",
    fontWeight: "inherit",
    gap: 2,
    textDecoration: "underline",
    textDecorationColor: "transparent",
    transition: "transition-color-medium",
    ...(disabled
      ? {}
      : {
          "&:focus-visible": {
            borderColor: "link01",
            borderRadius: "medium",
            borderStyle: "solid",
            color: "cta02Text",
            paddingX: 1,
            paddingY: 0
          },
          "&:hover": {
            color: "text-link-hover",
            textDecorationColor: "currentColor"
          },
          "&:active": {
            color: "text-link-click",
            textDecorationColor: "currentColor"
          }
        }),
    ...sx
  };

  return (
    <Target {...restProps} sx={{ ...linkStyles }} disabled={disabled}>
      {children}
    </Target>
  );
};
